export { default } from '@tencent/gh-qqnews-downapp'
